import { render, staticRenderFns } from "./apps-menu.vue?vue&type=template&id=0fe0b081&scoped=true&"
import script from "./apps-menu.vue?vue&type=script&lang=ts&"
export * from "./apps-menu.vue?vue&type=script&lang=ts&"
import style0 from "./apps-menu.vue?vue&type=style&index=0&id=0fe0b081&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0b081",
  null
  
)

export default component.exports